module.exports = __webpack_public_path__ + "img/nighthawk-logo.be69a981.svg";